export const ARHIV_POSJEDNIK = 'en~arhiv_posjednik';
export const POSJET = 'en~posjet';
export const REGISTRIRANI_KORISNIK = 'en~registrirani_korisnik';
